// extracted by mini-css-extract-plugin
export var linkText = "_qe-0";